import { CssBaseline } from '@mui/material/';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import useCreateTheme from './theme';

export interface LayoutProps {
  isDark: boolean;
  children: React.ReactNode;
}

const ThemeWrapper = ({ isDark, children }: LayoutProps) => {
  // const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

  return (
    <ThemeProvider theme={useCreateTheme(isDark)}>
      <CssBaseline />
      {/* <ToastContainer theme="light" /> */}
      {children}
    </ThemeProvider>
  );
};

export default ThemeWrapper;
